import React, { Component } from "react";

export default class TabBorderItem extends Component {
  render() {
    return (
      <li
        className={`${this.props.activePartsTab === "border" ? "active" : ""} ${
          this.props.themeDirection === "ltr" ? "item-EN" : ""
        }`}
        onClick={() => {
          this.props.partsTabHandler("border");
        }}
      >
        <svg width="100%" height="100%" viewBox="0 0 34 23" version="1.1">
          <g transform="matrix(1,0,0,1,-3295.92,-3164.76)">
            <g transform="matrix(1,0,0,1,-4870.89,3017.25)">
              <g transform="matrix(0.0399722,0,8.11535e-34,0.04245,8148.35,131.4)">
                <rect
                  x="524.416"
                  y="441.142"
                  width="707.127"
                  height="406.676"
                  style={{
                    fill: "#fff",

                    strokeWidth: "24.25px",
                  }}
                />
              </g>
            </g>
            <g transform="matrix(1,0,0,1,-4870.89,3017.25)">
              <g transform="matrix(0.0398423,0,0,0.0398423,8151.59,134.609)">
                <path
                  d="M394.569,336.198L1204.33,336.198L1204.33,776.975L1205.43,776.975L1205.43,876.036L395.673,876.036L395.673,868.871L394.569,868.871L394.569,435.259L394.569,336.198ZM493.63,435.259L493.63,776.975L1105.27,776.975L1105.27,435.259L493.63,435.259Z"
                  style={{
                    fill: "#fff",

                    strokeWidth: "25.1px",
                  }}
                />
              </g>
            </g>
          </g>
        </svg>
        <span>{this.props.texts["border"]}</span>
      </li>
    );
  }
}
